import { MyAccountInfo } from "PFCore/types";

export const minutesToHours = (minutes: number, suffix?: string) => {
  if (minutes === 0) {
    return `0${suffix ? `${suffix}` : ""}`;
  }

  const hours = Math.floor(minutes / 60);
  const minutesLeft = minutes % 60;

  const parsedMinutesToHours = `${hours}:${minutesLeft.toString().padStart(2, "0")}`;

  return suffix ? `${parsedMinutesToHours}${suffix}` : parsedMinutesToHours;
};

export const getDefaultNominalDayHours = (myAccountInfo: MyAccountInfo) => {
  const nominalDayMinutes = myAccountInfo?.availability.default_calendar?.default_nominal_day ?? 480;

  return minutesToHours(nominalDayMinutes);
};
